import { render, staticRenderFns } from "./address.vue?vue&type=template&id=c4fb6f40&scoped=true&"
import script from "./address.vue?vue&type=script&lang=js&"
export * from "./address.vue?vue&type=script&lang=js&"
import style0 from "./address.vue?vue&type=style&index=0&id=c4fb6f40&lang=scss&scoped=true&"
import style1 from "./address.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4fb6f40",
  null
  
)

export default component.exports